// extracted by mini-css-extract-plugin
export default {"root":"byJEEVllvIFFtcKK5BXv","header":"Q3Wl_DS2YGvlbD8YWcbf","title":"ySkR_zZTBAgw109KaR2x"};